/** Chip selector for the derived table of contents — not an OpenAI generate slot. */
export const CONTENT_LIST_SELECTOR = 'contentList';

export interface NavigationPartLock {
    selector?: string | null;
    loading?: boolean;
}

/**
 * „Obsah článku“ is built from headings. It must never keep loadingCompleted
 * false, or the cyan enhance/generate overlay holds the editor hostage.
 */
export function navigationLoadingCompleted(parts: NavigationPartLock[]): boolean {
    return parts.every((part) => part.selector === CONTENT_LIST_SELECTOR || !part.loading);
}

export function slotHasWrittenText(...values: Array<string | null | undefined>): boolean {
    return values.some((value) => String(value || '').replace(/<[^>]+>/g, ' ').trim().length > 0);
}

export function contentLoadingRatio(rows: Array<{h?: boolean; p?: boolean} | null | undefined>): number {
    let contentCount = 0;
    let contentLoading = 0;
    for (const subpart of rows) {
        contentCount += 2;
        contentLoading += subpart && subpart.h ? 1 : 0;
        contentLoading += subpart && subpart.p ? 1 : 0;
    }
    return contentCount ? contentLoading / contentCount : 0;
}
